"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * add safe area inset bottom to value
 */
function withSafeAreaInsetBottom(value) {
    if (!value) {
        return 'env(safe-area-inset-bottom)';
    }
    return "calc(env(safe-area-inset-bottom) + " + value + ")";
}
exports.default = withSafeAreaInsetBottom;
